/**
 * report-builder-api
 * API сервиса генерации отчетов
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Источник извлечения данных из ui-компонента: \'value\' | \'display\'.
 */
export type MappingType = 'value' | 'display';

export const MappingType = {
    Value: 'value' as MappingType,
    Display: 'display' as MappingType
};

